/* Inhairitance Curl ID quiz + result page.
   Reads #cid-config (Liquid) and window.CURL_ID_COPY (assets/curl-id-copy.js).
   No dependencies. */
(function () {
  'use strict';

  var SELF_SRC = (document.currentScript && document.currentScript.src) || '';
  var root = document.getElementById('cid');
  var cfgEl = document.getElementById('cid-config');
  if (!root || !cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[Curl ID] config JSON is invalid', e); return; }
  var COPY = window.CURL_ID_COPY || {};

  /* ---------- Shared data: assets/curl-id-copy.js (product IDs, kits, names) ---------- */
  var D = window.CURL_ID_DATA || {};
  var PRODUCT_IDS = D.PRODUCT_IDS, HANDLE_HINTS = D.HANDLE_HINTS, KIT_VARIANTS = D.KIT_VARIANTS, NAMES = D.NAMES, CURL_IDS = D.CURL_IDS;
  var LOOKS = { definition: 'Definition', volume: 'Volume', both: 'Volume & Definition' };
  var TYPE_WORD = { 2: 'Wavy', 3: 'Curly', 4: 'Coily' };
  var TYPE_NOUN = { 2: 'waves', 3: 'curls', 4: 'coils' };
  var STORE_KEY = 'inh_curl_id_v1';
  var SAVE_DAYS = 90;

  try { var ov = JSON.parse(CFG.idOverrides || '{}'); Object.keys(ov).forEach(function (k) { PRODUCT_IDS[k] = Number(ov[k]); }); } catch (e) { console.warn('[Curl ID] Product ID overrides are not valid JSON'); }

  var PRODUCTS = (CFG.products || []).filter(Boolean);
  var byId = {}; PRODUCTS.forEach(function (p) { byId[p.id] = p; });
  var variantIndex = {}; PRODUCTS.forEach(function (p) { p.variants.forEach(function (v) { variantIndex[v.id] = { p: p, v: v }; }); });
  var resolved = {};
  function product(key) {
    if (key in resolved) return resolved[key];
    var p = PRODUCT_IDS[key] ? byId[PRODUCT_IDS[key]] : null;
    if (!p && HANDLE_HINTS[key]) {
      var isKit = /kit/.test(key);
      p = PRODUCTS.filter(function (x) {
        if (!HANDLE_HINTS[key].test(x.handle)) return false;
        if (!isKit && /kit|bundle|sample|travel/.test(x.handle)) return false;
        return true;
      })[0] || null;
    }
    if (!p) console.warn('[Curl ID] Not in the quiz collection: ' + key);
    resolved[key] = p;
    return p;
  }
  function pickVariant(p, prefer) {
    if (!p) return null;
    var vs = p.variants.filter(function (v) { return v.available; });
    if (!vs.length) return null;
    if (prefer) { var m = vs.filter(function (v) { return prefer.test(v.title); })[0]; if (m) return m; }
    var eight = vs.filter(function (v) { return /8\s?oz|236|250\s?ml/i.test(v.title); })[0];
    return eight || vs[0];
  }
  function norm(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function kitFor(key, look) {
    var ids = KIT_VARIANTS[key]; if (!ids) return null;
    var hit = variantIndex[ids[0]] || variantIndex[ids[1]]; if (!hit) return null;
    var p = hit.p, v = null;
    if (look === 'definition') v = (variantIndex[ids[0]] || {}).v;
    else if (look === 'volume') v = (variantIndex[ids[1]] || {}).v;
    else v = p.variants.filter(function (x) { var t = norm(x.title); return t.indexOf('volume') > -1 && t.indexOf('definition') > -1; })[0];
    /* No Volume & Definition variant: sell the Definition kit + the one product that makes it V&D, as an optional add-on */
    if (look === 'both' && !v) return { p: p, v: (variantIndex[ids[0]] || {}).v || null, fallback: true };
    return { p: p, v: v || null };
  }
  /* What the result shows as "the kit" for a look, plus the optional add-on when V&D falls back to Definition */
  function kitView(copy, key, look) {
    var kit = kitFor(key, look);
    if (!(kit && kit.fallback)) return { kit: kit, items: copy.kit[look].items, addon: null };
    var def = copy.kit.definition.items, inDef = def.map(function (i) { return i.product; });
    var add = copy.kit.both.items.filter(function (i) { return inDef.indexOf(i.product) < 0; })[0];
    var av = add && pickVariant(product(add.product));
    var dropsML = inDef.indexOf('moisture_lock') > -1 && !copy.kit.both.items.some(function (i) { return i.product === 'moisture_lock'; });
    return { kit: kit, items: def, addon: add && av ? { key: add.product, line: add.line, v: av } : null, dropsML: dropsML };
  }

  /* ---------- Helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lang() {
    try { if (window.Weglot && Weglot.getCurrentLang) return Weglot.getCurrentLang().slice(0, 2); } catch (e) {}
    return (document.documentElement.lang || CFG.locale || 'en').slice(0, 2);
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || 'CAD';
    try { return new Intl.NumberFormat(lang() === 'fr' ? 'fr-CA' : 'en-CA', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function ses(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function listJoin(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function curlIdFrom(strands, por) {
    var thick = strands !== 'fine', low = por === 'low';
    return thick ? (low ? 'velvet-babe' : 'deluxe-princess') : (low ? 'protective-goddess' : 'tlc-queen');
  }
  function lookFromGoal(g) { return g === 'volume' ? 'volume' : g === 'both' ? 'both' : 'definition'; }
  function nameHtml(name, cls) {
    /* Brand rule: script font never for all-caps words (TLC renders in Futura). */
    return '<span class="cid-idname ' + (cls || '') + '">' + name.split(' ').map(function (w) {
      return /^[A-Z0-9]{2,}$/.test(w) ? '<span class="cid-caps">' + esc(w) + '</span>' : '<span class="cid-script">' + esc(w) + '</span>';
    }).join(' ') + '</span>';
  }
  function abs(url) { try { return new URL(url, location.origin).href; } catch (e) { return url; } }

  /* ---------- Questions ---------- */
  var OPTS = {
    goal: [
      { v: 'volume', t: 'Volume', d: 'Big, full, day one' },
      { v: 'definition', t: 'Definition', d: 'Lasts to next wash day' },
      { v: 'both', t: 'A bit of both', d: 'Full and defined' }
    ],
    strands: [
      { v: 'fine', t: 'Delicate', d: 'Fine strands', w: 1.2 },
      { v: 'medium', t: 'Distinct', d: 'Medium strands', w: 2.6 },
      { v: 'thick', t: 'Robust', d: 'Thick strands', w: 4.4 }
    ],
    porosity: [
      { v: 'high', t: 'It absorbs right away' },
      { v: 'medium', t: 'It takes a bit of time to absorb' },
      { v: 'low', t: 'It barely absorbs, product stays on top' }
    ],
    scalp: [{ v: 'oily', t: 'Oily' }, { v: 'dry', t: 'Dry' }, { v: 'flaky', t: 'Flaky' }, { v: 'itchy', t: 'Itchy' }, { v: 'none', t: 'No issues' }],
    history: [
      { v: 'colour', t: 'Colour, bleach or dye' }, { v: 'straightening', t: 'Chemical straightening or keratin' },
      { v: 'heat', t: 'Heat tools like flat irons' }, { v: 'breakage', t: 'Breakage or shedding' },
      { v: 'detangling', t: 'Trouble detangling' }, { v: 'none', t: 'None of these' }
    ],
    life: [
      { v: 'workout', t: 'I work out' }, { v: 'swim', t: 'I swim regularly, in a pool or the ocean' },
      { v: 'extensions', t: 'I wear synthetic extensions' }, { v: 'none', t: 'None of these' }
    ]
  };
  function label(q, v) { var o = (OPTS[q] || []).filter(function (x) { return x.v === v; })[0]; return o ? o.t : v; }
  var DAMAGE = ['colour', 'straightening', 'heat', 'breakage'];

  var STEPS = ['goal', 'curl', 'proof', 'strands', 'porosity', 'reveal', 'scalp', 'history', 'life', 'email'];
  var COUNT = { goal: 1, curl: 2, strands: 3, porosity: 4, scalp: 5, history: 6, life: 7 };
  var A = { goal: null, type: null, strands: null, porosity: null, scalp: [], history: [], life: [], lang: null };
  var stepIdx = 0, curlFallback = false, showStrandHelp = false;

  function skip(step) {
    if (step === 'proof') return !A.type || !(CFG.proof || {})[A.type];
    if (step === 'email') return CFG.isB2B;
    return false;
  }
  function go(i, push) {
    while (i < STEPS.length && skip(STEPS[i])) i++;
    if (i >= STEPS.length) return finish();
    stepIdx = i; curlFallback = false; showStrandHelp = false;
    if (push !== false) try { history.pushState({ cidStep: i }, '', location.pathname + location.search); } catch (e) {}
    render();
    root.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
  }
  function prevStep() {
    var i = stepIdx - 1;
    while (i >= 0 && skip(STEPS[i])) i--;
    return i;
  }
  function back(toStep) {
    var i = STEPS.indexOf(toStep);
    if (i > -1) go(i);
  }
  window.addEventListener('popstate', function (e) {
    if (e.state && typeof e.state.cidStep === 'number') { stepIdx = e.state.cidStep; render(); }
    else if (!params().id && stepIdx > 0) { stepIdx = 0; render(); }
  });

  /* ---------- Shared chrome ---------- */
  function header(step) {
    var n = COUNT[step];
    var titles = { proof: 'Curls like yours, unlocked', reveal: 'Your Curl ID', email: 'Your plan is ready' };
    var pct = { goal: 10, curl: 24, proof: 30, strands: 38, porosity: 50, reveal: 58, scalp: 66, history: 78, life: 90, email: 100 }[step];
    var prev = prevStep();
    return '<div class="cid-top"><div class="cid-top-row">' +
      (prev > -1 ? '<button type="button" class="cid-backbtn" data-act="prev" aria-label="Back to the previous question"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>Back</button>' : '<div class="cid-kicker">Curl ID</div>') +
      '<div class="cid-count">' + (n ? n + ' of 7' : esc(titles[step] || '')) + '</div></div>' +
      '<div class="cid-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div></div>';
  }
  function stylist() {
    var st = CFG.stylist || {};
    /* photo as a background on the circle: theme or app image scripts can't hide or resize it */
    var av = st.avatar ? '<span class="cid-avatar-img" role="img" aria-label="' + esc(st.name || 'Curl Expert') + '" style="background-image:url(\'' + esc(st.avatar) + '\')"></span>' :
      '<svg width="30" height="30" viewBox="0 0 30 30" fill="#fff" aria-hidden="true"><circle cx="15" cy="11" r="6"/><path d="M3 30c1-7 6-10 12-10s11 3 12 10z"/></svg>';
    return '<div class="cid-stylist"><div class="cid-avatar">' + av + '</div><div><div class="cid-st-name">' + esc(st.name || '') +
      '</div><div class="cid-st-title">' + esc(st.title || 'Curl Expert') + '</div></div></div>';
  }
  var bubbleN = 0, instant = false;
  function bubble(text, kind) {
    var d = reduced() || instant ? 0 : (bubbleN++) * 420;
    return '<div class="cid-bubble' + (kind === 'aff' ? ' cid-aff' : '') + '" style="animation-delay:' + d + 'ms">' + text + '</div>';
  }
  function after() { return reduced() || instant ? 0 : bubbleN * 420 + 80; }
  function chip(step, text) {
    return '<button type="button" class="cid-chip" data-back="' + step + '" aria-label="Change answer: ' + esc(text) + '">' + esc(text) + '</button>';
  }
  function frame(step, inner, foot) {
    var panel = '<aside class="cid-panel" aria-hidden="true">' +
      (CFG.brandVideo ? '<video class="cid-panel-media" src="' + esc(CFG.brandVideo) + '"' + (CFG.brandPoster ? ' poster="' + esc(CFG.brandPoster) + '"' : '') + ' autoplay muted loop playsinline preload="metadata"></video>'
        : (CFG.brandPoster ? '<img class="cid-panel-media" src="' + esc(CFG.brandPoster) + '" alt="">' : '<div class="cid-panel-media"></div>')) +
      '<p class="cid-panel-line">' + esc(CFG.proofLine || '') + '</p></aside>';
    return '<div class="cid-quiz cid-step-' + step + '">' + panel + '<div class="cid-main">' + header(step) +
      '<div class="cid-body">' + inner + '</div>' + (foot ? '<div class="cid-foot">' + foot + '</div>' : '') + '</div></div>';
  }

  /* ---------- Step renderers ---------- */
  var R = {};
  R.goal = function () {
    var saved = store(STORE_KEY), banner = '';
    if (saved && saved.url && !CFG.isB2B) {
      var days = (Date.now() - saved.savedAt) / 864e5;
      banner = days > SAVE_DAYS
        ? '<div class="cid-saved"><strong>It\'s been 3 months.</strong> Want to check your Curl ID again? Porosity can change as your hair gets healthier.</div>'
        : '<div class="cid-saved"><div><div class="cid-saved-k">Your saved routine</div><div class="cid-saved-n">' + esc(saved.name) + ' · Type ' + esc(saved.type) + ' · ' + esc(LOOKS[saved.look] || '') + '</div></div>' +
          '<a class="cid-btn cid-btn-sm" href="' + esc(savedHere(saved.url)) + '">View my routine</a></div>';
    }
    var cards = OPTS.goal.map(function (o) {
      var img = (CFG.goalImages || {})[o.v];
      return '<button type="button" class="cid-card cid-goal" data-a="goal" data-v="' + o.v + '" aria-pressed="' + (A.goal === o.v) + '">' +
        '<span class="cid-card-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="cid-card-txt"><span class="cid-card-t">' + esc(o.t) + '</span><span class="cid-card-d">' + esc(o.d) + '</span></span></button>';
    }).join('');
    var perks = CFG.isB2B ? '' : '<ul class="cid-perks" role="list">' +
      '<li><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v8H4v-8M2 7h20v5H2zM12 22V7M12 7c-1.5-3-5-4-5.5-1.5S9.5 7 12 7zm0 0c1.5-3 5-4 5.5-1.5S14.5 7 12 7z"/></svg><span>Up to 15% off your Curl ID Kit</span></li>' +
      '<li><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2l8 3v6c0 5-3.5 9-8 11-4.5-2-8-6-8-11V5z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg><span>30-Day Curl Expert Guarantee</span></li></ul>';
    return frame('goal', banner + perks + stylist() +
      bubble('Hey Curl Jewel, I\'m ' + esc(firstWord(CFG.stylist && CFG.stylist.name)) + '. Let\'s find your Curl ID.') +
      bubble('There\'s no such thing as difficult hair, just hair that hasn\'t been understood yet.', 'aff') +
      bubble('First, the fun part. How do you love to wear your crown?') +
      '<div class="cid-grid cid-grid-goal cid-in" style="animation-delay:' + after() + 'ms">' + cards + '</div>',
      '<p class="cid-note">7 quick questions. Tap any answer later to change it.</p>');
  };
  function firstWord(n) { n = String(n || '').trim(); return /^\[/.test(n) ? n : n.split(' ')[0]; }

  var GOAL_REACT = {
    volume: 'Big, full and fabulous from day one, love that.',
    definition: 'Definition that lasts to wash day, love that.',
    both: 'Full and defined, the best of both worlds.',
    protective: 'Protective styles are a beautiful way to care for your crown. Let\'s keep the hair underneath healthy and happy.'
  };
  R.curl = function () {
    var inner = chip('goal', label('goal', A.goal)) + stylist() + bubble(GOAL_REACT[A.goal] + ' Now, whose curls look most like yours when they dry on their own?');
    var models = CFG.models || [];
    if (curlFallback || !models.length) {
      inner += '<div class="cid-list cid-in" style="animation-delay:' + after() + 'ms">' + [
        { t: 2, n: 'Waves', d: 'S-shaped bends that sit close to the head' },
        { t: 3, n: 'Curls', d: 'Springy loops and ringlets' },
        { t: 4, n: 'Coils', d: 'Tight coils and zigzags with lots of shrinkage' }
      ].map(function (o) {
        return '<button type="button" class="cid-row" data-a="type" data-v="' + o.t + '" aria-pressed="' + (A.type === o.t) + '"><span class="cid-card-t">' + o.n + ', Type ' + o.t + '</span><span class="cid-card-d">' + o.d + '</span></button>';
      }).join('') + '</div>';
    } else {
      inner += '<div class="cid-grid cid-grid-models cid-in" style="animation-delay:' + after() + 'ms">' + models.map(function (m, i) {
        return '<button type="button" class="cid-model" data-a="type" data-v="' + m.type + '" data-i="' + i + '" aria-label="' + esc(m.alt || 'Curls like this model') + '" aria-pressed="' + (A.modelIdx === i) + '"><img src="' + esc(m.img) + '" alt="" loading="lazy"></button>';
      }).join('') + '</div>';
    }
    var foot = (models.length && !curlFallback) ? '<button type="button" class="cid-link" data-act="curl-fallback">None of these look like my hair</button>' : '';
    return frame('curl', inner, foot);
  };
  R.proof = function () {
    var img = CFG.proof[A.type];
    return frame('proof', chip('curl', 'Type ' + A.type) + stylist() +
      bubble('Look at the difference the right products make. Same Curl Jewel, same Type ' + A.type + ' ' + TYPE_NOUN[A.type] + ' as you, before and after her Curl ID products.') +
      '<figure class="cid-proof cid-in" style="animation-delay:' + after() + 'ms"><img src="' + esc(img) + '" alt="Before and after Curl ID products, Type ' + A.type + '"><figcaption><span>Before</span><span>After</span></figcaption></figure>' +
      bubble('Two more quick questions and I\'ll find your Curl ID.'),
      '<button type="button" class="cid-btn" data-act="next">Keep going</button>');
  };
  R.strands = function () {
    var opts = OPTS.strands.map(function (o) {
      return '<button type="button" class="cid-row cid-row-icon" data-a="strands" data-v="' + o.v + '" aria-pressed="' + (A.strands === o.v) + '">' +
        '<svg width="44" height="24" viewBox="0 0 44 24" fill="none" stroke="currentColor" stroke-width="' + o.w + '" stroke-linecap="round" aria-hidden="true"><path d="M2 12c6-8 10 8 16 0s10 8 16 0 6-4 8-2"/></svg>' +
        '<span><span class="cid-card-t">' + o.t + '</span><span class="cid-card-d">' + o.d + '</span></span></button>';
    }).join('');
    var help = showStrandHelp && CFG.strandHelp ? '<img class="cid-help-img" src="' + esc(CFG.strandHelp) + '" alt="Fine, medium and thick strands side by side">' : '';
    return frame('strands', chip(CFG.proof && CFG.proof[A.type] ? 'proof' : 'curl', 'Type ' + A.type) + stylist() +
      bubble('Type ' + A.type + ' ' + TYPE_NOUN[A.type] + '. Your beautiful texture was passed down to you by your ancestors, so let\'s learn exactly how to care for it.', 'aff') +
      bubble('How thick is a single strand of your hair?') +
      '<div class="cid-tip cid-in" style="animation-delay:' + after() + 'ms"><div class="cid-tip-k">Pro tip</div><p>Take a single strand from the side of your head (avoiding the hairline) and roll it between your fingers. Does it feel delicate, distinct or robust?</p>' + help + '</div>' +
      '<div class="cid-list cid-in" style="animation-delay:' + after() + 'ms">' + opts + '</div>',
      CFG.strandHelp && !showStrandHelp ? '<button type="button" class="cid-link" data-act="strand-help">Not sure? See photos</button>' : '');
  };
  var STRAND_REACT = {
    fine: 'Fine strands are delicate, not weak. They just need more gentle &amp; protective care.',
    medium: 'Medium strands have a lovely balance of strength and softness.',
    thick: 'Thick strands are strong and love rich, nourishing layers.'
  };
  R.porosity = function () {
    var opts = OPTS.porosity.map(function (o) {
      return '<button type="button" class="cid-row" data-a="porosity" data-v="' + o.v + '" aria-pressed="' + (A.porosity === o.v) + '"><span class="cid-card-t cid-plain">' + esc(o.t) + '</span></button>';
    }).join('');
    return frame('porosity', chip('strands', strandLabel()) + stylist() +
      bubble(STRAND_REACT[A.strands], 'aff') +
      bubble('Last one about your hair. When your hair is freshly washed, how quickly does it absorb conditioner?') +
      '<p class="cid-help cid-in" style="animation-delay:' + after() + 'ms">This tells us your hair\'s porosity: how easily it takes in moisture and how well it holds on to it.</p>' +
      '<div class="cid-list cid-in" style="animation-delay:' + after() + 'ms">' + opts + '</div>');
  };
  function strandLabel() { var o = OPTS.strands.filter(function (x) { return x.v === A.strands; })[0]; return o.t + ', ' + o.d.toLowerCase(); }
  function porKey() { return A.porosity === 'low' ? 'low' : 'medhigh'; }
  function chipsFor(id, type) {
    var c = CURL_IDS[id];
    return ['Type ' + type, (c.strands === 'fine' ? 'Fine' : 'Thick') + ' strands', c.por === 'low' ? 'Low porosity' : 'Med to high porosity', TYPE_WORD[type]]
      .map(function (t) { return '<span class="cid-pill">' + esc(t) + '</span>'; }).join('');
  }
  R.reveal = function () {
    var id = curlIdFrom(A.strands, A.porosity), c = CURL_IDS[id], copy = COPY[id + '-' + A.type] || {};
    var kit = kitFor(id + '-' + A.type, lookFromGoal(A.goal)), m = kit && kit.p.media || {};
    var photo = m[{ definition: 'afterDefinition', volume: 'afterVolume', both: 'afterBoth' }[lookFromGoal(A.goal)]] || m.afterDefinition;
    return frame('reveal', chip('porosity', label('porosity', A.porosity)) +
      '<div class="cid-reveal cid-in">' +
      '<div class="cid-reveal-k">Your Curl ID is</div>' + nameHtml(c.name, 'cid-idname-xl') +
      '<div class="cid-pills">' + chipsFor(id, A.type) + '</div>' +
      (copy.tagline ? '<p class="cid-reveal-tag">' + esc(copy.tagline) + '</p>' : '') +
      (photo ? '<img class="cid-reveal-img" src="' + esc(photo) + '" alt="' + esc(c.name) + ' Type ' + A.type + ' result">' : '') +
      '<p class="cid-reveal-note">Remember: your Curl ID isn\'t a label. It\'s a starting point, and it can change as your hair gets healthier.</p></div>',
      '<button type="button" class="cid-btn" data-act="next">Keep going</button><p class="cid-note">3 quick questions so your routine fits your week</p>');
  };
  /* Scalp icons (no photos needed) */
  var SCALP_ICONS = {
    oily: '<path d="M24 7c-5 7-10 13-10 19a10 10 0 0 0 20 0c0-6-5-12-10-19z"/><path d="M19 27a5 5 0 0 0 5 5"/>',
    dry: '<circle cx="24" cy="24" r="7"/><path d="M24 7v4M24 37v4M7 24h4M37 24h4M12 12l3 3M33 33l3 3M36 12l-3 3M15 33l-3 3"/>',
    flaky: '<path d="M24 8v32M10 16l28 16M38 16L10 32"/><path d="M20 10l4 4 4-4M20 38l4-4 4 4"/>',
    itchy: '<path d="M10 16c3-3 5 3 8 0s5 3 8 0 5 3 8 0 4 2 4 2"/><path d="M10 24c3-3 5 3 8 0s5 3 8 0 5 3 8 0 4 2 4 2"/><path d="M10 32c3-3 5 3 8 0s5 3 8 0 5 3 8 0 4 2 4 2"/>',
    none: '<circle cx="24" cy="24" r="15"/><path d="M17 24.5l5 5 9-10"/>'
  };
  function scalpIcon(v) { return '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (SCALP_ICONS[v] || '') + '</svg>'; }
  function multi(q, withImg) {
    return OPTS[q].filter(function (o) { return !(q === 'life' && o.v === 'extensions' && A.goal === 'protective'); }).map(function (o) {
      var on = A[q].indexOf(o.v) > -1;
      return '<button type="button" class="cid-' + (withImg ? 'card cid-scalp' : 'row cid-check') + '" data-m="' + q + '" data-v="' + o.v + '" aria-pressed="' + on + '">' +
        (withImg ? '<span class="cid-scalp-icon">' + scalpIcon(o.v) + '</span>' : '<span class="cid-box" aria-hidden="true"></span>') +
        '<span class="cid-card-t' + (withImg ? '' : ' cid-plain') + '">' + esc(o.t) + '</span></button>';
    }).join('');
  }
  function contBtn(q, text) { return '<button type="button" class="cid-btn" data-act="next"' + (A[q].length ? '' : ' disabled') + '>' + (text || 'Continue') + '</button>'; }
  R.scalp = function () {
    return frame('scalp', chip('reveal', CURL_IDS[curlIdFrom(A.strands, A.porosity)].name) + stylist() +
      bubble('You\'re doing amazing. Three more and your complete curl care plan is ready.', 'aff') +
      bubble('Now let\'s make it fit your life. How would you describe your scalp?') +
      '<p class="cid-help cid-in" style="animation-delay:' + after() + 'ms">Pick all that apply</p>' +
      '<div class="cid-grid cid-grid-scalp cid-in" style="animation-delay:' + after() + 'ms">' + multi('scalp', true) + '</div>', contBtn('scalp'));
  };
  function scalpReact() {
    if (A.scalp.indexOf('none') > -1) return 'A happy scalp is the foundation of healthy curls. Love that for you.';
    return 'So common, and it usually comes down to buildup. You\'re in good hands. I\'ll add a scalp reset to your wash day.';
  }
  function chipList(q) { return A[q].map(function (v) { return label(q, v).split(/[ ,]/)[0]; }).join(', '); }
  R.history = function () {
    return frame('history', chip('scalp', chipList('scalp')) + stylist() + bubble(scalpReact(), 'aff') +
      bubble('In the last 6 months, have you had any of these?') +
      '<p class="cid-help cid-in" style="animation-delay:' + after() + 'ms">Pick all that apply</p>' +
      '<div class="cid-list cid-in" style="animation-delay:' + after() + 'ms">' + multi('history') + '</div>', contBtn('history'));
  };
  function historyReact() {
    var h = A.history, dmg = h.filter(function (v) { return DAMAGE.indexOf(v) > -1; }), tangles = h.indexOf('detangling') > -1;
    if (h.indexOf('none') > -1) return 'Love that your hair has had a calm few months.';
    if (!dmg.length) return 'Tangles happen to all of us. I\'ll add more slip to make detangling easier.';
    return 'No judgment here. ' + (h.indexOf('colour') > -1 ? 'Colour can add so much fun and joy to your style. ' : '') +
      'I\'ll add a little extra strength' + (tangles ? ', plus more slip for those tangles.' : '.');
  }
  R.life = function () {
    return frame('life', chip('history', chipList('history')) + stylist() + bubble(historyReact(), 'aff') +
      bubble('Last one. Are any of these part of your week?') +
      '<p class="cid-help cid-in" style="animation-delay:' + after() + 'ms">Pick all that apply</p>' +
      '<div class="cid-list cid-in" style="animation-delay:' + after() + 'ms">' + multi('life') + '</div>', contBtn('life', 'Build my curl care plan'));
  };
  function emailForm(where) {
    var l = A.lang || lang(), c = CFG.customer || {};
    return '<form class="cid-form" data-form="' + where + '" novalidate>' +
      (where === 'quiz' ? '<label class="cid-field"><span>First name</span><input name="first" autocomplete="given-name" value="' + esc(c.firstName || '') + '"></label>' : '') +
      '<label class="cid-field"><span>Email</span><input name="email" type="email" autocomplete="email" required value="' + esc(c.email || '') + '"></label>' +
      '<fieldset class="cid-lang"><legend>Send my results in</legend>' +
      '<label><input type="radio" name="lang" value="en"' + (l !== 'fr' ? ' checked' : '') + '><span>English</span></label>' +
      '<label><input type="radio" name="lang" value="fr"' + (l === 'fr' ? ' checked' : '') + '><span>Français</span></label></fieldset>' +
      '<label class="cid-consent"><input type="checkbox" name="consent"><span>Yes, send me curl tips and offers from Inhairitance. Unsubscribe anytime.</span></label>' +
      '<p class="cid-err" role="alert" hidden>Please enter a valid email.</p>' +
      '<button type="submit" class="cid-btn">' + (where === 'quiz' ? 'Send my plan + my code' : 'Email me my plan + code') + '</button>' +
      (CFG.termsUrl ? '<p class="cid-fine">By continuing you agree to our <a href="' + esc(CFG.termsUrl) + '">Terms &amp; Conditions</a>.</p>' : '') + '</form>';
  }
  R.email = function () {
    return frame('email', chip('life', chipList('life')) + stylist() +
      bubble('Look at you centering yourself and your hair\'s needs.', 'aff') +
      bubble('Your complete curl care plan is ready! Want me to email it to you?') +
      '<div class="cid-gift cid-in" style="animation-delay:' + after() + 'ms"><strong>Your welcome gift:</strong> an extra 5% off your Curl ID Kit, on top of the 10% kit savings. That\'s 15% off in total, plus our 30-Day Curl Expert Guarantee. Your code arrives in a minute or two.</div>' +
      '<div class="cid-in" style="animation-delay:' + after() + 'ms">' + emailForm('quiz') + '</div>',
      '<button type="button" class="cid-link" data-act="skip">Skip, show my results</button>');
  };

  function render() {
    bubbleN = 0;
    root.innerHTML = R[STEPS[stepIdx]]();
    root.setAttribute('data-view', 'quiz');
  }

  /* ---------- Quiz events ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button, a'); if (!b || !root.contains(b)) return;
    if (b.dataset.back) return back(b.dataset.back);
    if (b.dataset.a) {
      var k = b.dataset.a, v = b.dataset.v;
      if (k === 'type') { A.type = Number(v); A.modelIdx = b.dataset.i != null ? Number(b.dataset.i) : null; }
      else A[k] = v;
      b.setAttribute('aria-pressed', 'true');
      return setTimeout(function () { go(stepIdx + 1); }, reduced() ? 0 : 220);
    }
    if (b.dataset.m) {
      var q = b.dataset.m, val = b.dataset.v, arr = A[q];
      if (val === 'none') A[q] = arr.indexOf('none') > -1 ? [] : ['none'];
      else { arr = arr.filter(function (x) { return x !== 'none'; }); var i = arr.indexOf(val); if (i > -1) arr.splice(i, 1); else arr.push(val); A[q] = arr; }
      root.querySelectorAll('[data-m="' + q + '"]').forEach(function (el) { el.setAttribute('aria-pressed', String(A[q].indexOf(el.dataset.v) > -1)); });
      var nb = root.querySelector('[data-act="next"]'); if (nb) nb.disabled = !A[q].length;
      return;
    }
    var act = b.dataset.act;
    if (act === 'next') return go(stepIdx + 1);
    if (act === 'prev') { var pi = prevStep(); if (pi > -1) go(pi); return; }
    if (act === 'curl-fallback') { curlFallback = true; bubbleN = 0; root.innerHTML = R.curl(); return; }
    if (act === 'strand-help') {
      showStrandHelp = true; instant = true; root.innerHTML = R.strands(); instant = false;
      var hi = root.querySelector('.cid-help-img'); if (hi) hi.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
      return;
    }
    if (act === 'skip') return finish();
  });
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('form.cid-form'); if (!f) return;
    e.preventDefault();
    var email = f.email.value.trim(), err = f.querySelector('.cid-err');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.hidden = false; f.email.focus(); return; }
    err.hidden = true;
    var data = { email: email, first: f.first ? f.first.value.trim() : '', lang: (f.querySelector('[name=lang]:checked') || {}).value || 'en', consent: f.consent.checked };
    var btn = f.querySelector('[type=submit]'); btn.disabled = true; btn.textContent = 'Sending...';
    if (f.dataset.form === 'quiz') {
      A.lang = data.lang;
      var done = false, next = function () { if (!done) { done = true; finish(data); } };
      sendToKlaviyo(data, resultState()).then(next, next);
      setTimeout(next, 2500);
    } else {
      var st = resultState();
      sendToKlaviyo(data, st).then(function () {
        ses('cid_emailed', '1'); saveLocal(st, true);
        f.outerHTML = '<p class="cid-sent">Sent! Your Curl ID, your plan and your extra 5% code are on their way. They usually arrive in a minute or two.</p>';
      }, function () { btn.disabled = false; btn.textContent = 'Email me my plan + code'; err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; });
    }
  });

  /* ---------- Result state + URL ---------- */
  function params() { var o = {}; new URLSearchParams(location.search).forEach(function (v, k) { o[k] = v; }); return o; }
  function resultState() {
    var id = curlIdFrom(A.strands, A.porosity);
    return { id: id, type: A.type, look: lookFromGoal(A.goal), goal: A.goal, strands: A.strands, porosity: A.porosity,
      scalp: A.scalp, history: A.history, life: A.life, lang: A.lang || lang() };
  }
  /* a saved routine always opens on the quiz page you're on now (older saves may hold another page's path) */
  function savedHere(u) { var i = String(u || '').indexOf('?'); return location.pathname + (i > -1 ? String(u).slice(i) : ''); }
  function urlFor(st, look) {
    var q = new URLSearchParams();
    q.set('id', st.id); q.set('type', st.type); q.set('look', look || st.look);
    if (st.goal) q.set('goal', st.goal);
    if (st.strands) q.set('strands', st.strands);
    if (st.porosity) q.set('por', st.porosity);
    if (st.scalp && st.scalp.length) q.set('scalp', st.scalp.join(','));
    if (st.history && st.history.length) q.set('hist', st.history.join(','));
    if (st.life && st.life.length) q.set('life', st.life.join(','));
    if (st.code) q.set('code', st.code);
    return location.pathname + '?' + q.toString();
  }
  function stateFromParams(p) {
    if (!CURL_IDS[p.id] || [2, 3, 4].indexOf(Number(p.type)) < 0) return null;
    var split = function (s) { return s ? s.split(',').filter(Boolean) : []; };
    return { id: p.id, type: Number(p.type), look: LOOKS[p.look] ? p.look : 'definition', goal: p.goal || null,
      strands: p.strands || null, porosity: p.por || null, scalp: split(p.scalp), history: split(p.hist), life: split(p.life),
      code: p.code || null, lang: lang() };
  }
  function saveLocal(st, emailed) {
    if (CFG.isB2B) return;
    var prev = store(STORE_KEY) || {};
    store(STORE_KEY, { url: urlFor(st), id: st.id, type: st.type, look: st.look, name: CURL_IDS[st.id].name, savedAt: Date.now(), emailed: emailed || prev.emailed || false });
  }
  function finish(emailData) {
    var st = resultState();
    if (emailData) ses('cid_emailed', '1');
    saveLocal(st, !!emailData);
    try { history.pushState({}, '', urlFor(st)); } catch (e) { location.href = urlFor(st); return; }
    renderResult(st);
  }

  /* ---------- Klaviyo (client API, public key) ---------- */
  function kitNames(st, look) { var c = COPY[st.id + '-' + st.type]; return c ? c.kit[look].items.map(function (i) { return NAMES[i.product]; }) : []; }
  /* French copy for the emails: loaded only when she picks Français (assets/curl-id-email-fr.js) */
  function loadFr() {
    if (window.CURL_ID_EMAIL_FR) return Promise.resolve();
    var src = SELF_SRC.replace(/curl-id-quiz\.js(\?.*)?$/, 'curl-id-email-fr.js');
    if (!src || src === SELF_SRC) return Promise.resolve();
    return new Promise(function (ok) {
      var sc = document.createElement('script'); sc.src = src; sc.async = true;
      sc.onload = sc.onerror = function () { ok(); };
      document.head.appendChild(sc);
      setTimeout(ok, 2500);
    });
  }
  function sendToKlaviyo(d, st) {
    return (d.lang === 'fr' ? loadFr() : Promise.resolve()).then(function () { return sendToKlaviyoNow(d, st); });
  }
  function sendToKlaviyoNow(d, st) {
    var K = CFG.klaviyo || {};
    if (!K.publicKey || CFG.isB2B) { console.warn('[Curl ID] Klaviyo public key missing; nothing sent.'); return Promise.resolve(); }
    var kit = kitFor(st.id + '-' + st.type, st.look), m = kit && kit.p.media || {};
    var kv = COPY[st.id + '-' + st.type] ? kitView(COPY[st.id + '-' + st.type], st.id + '-' + st.type, st.look) : { items: [], addon: null };
    var picks = buildPicks(st).map(function (p) { return NAMES[p.key]; });
    var props = {
      'Curl ID': CURL_IDS[st.id].name, 'Curl ID Type': st.type, 'Curl ID Full': CURL_IDS[st.id].name + ' ' + st.type,
      'Curl ID Look': LOOKS[st.look], 'Curl ID Crown Goal': st.goal ? label('goal', st.goal) : null,
      'Curl ID Strands': st.strands, 'Curl ID Porosity': st.porosity ? label('porosity', st.porosity) : null,
      'Curl ID Porosity Group': CURL_IDS[st.id].por === 'low' ? 'Low' : 'Medium to high',
      'Curl ID Scalp': st.scalp.map(function (v) { return label('scalp', v); }),
      'Curl ID Hair History': st.history.map(function (v) { return label('history', v); }),
      'Curl ID Lifestyle': st.life.map(function (v) { return label('life', v); }),
      'Curl ID Language': d.lang === 'fr' ? 'French' : 'English',
      'Curl ID Plan URL': abs(urlFor(st)),
      'Curl ID Video URL': m['video' + { definition: 'Definition', volume: 'Volume', both: 'Both' }[st.look]] || m.videoDefinition || null,
      'Curl ID Guide URL': (d.lang === 'fr' ? m.guideFr : m.guideEn) || m.guideEn || null,
      'Curl ID Quiz Date': new Date().toISOString()
    };
    var evProps = Object.assign({}, props, {
      'Kit Products': kv.addon ? kv.items.map(function (i) { return NAMES[i.product]; }) : kitNames(st, st.look),
      'Kit Add-On': kv.addon ? NAMES[kv.addon.key] : null,
      'Kit Add-On URL': kv.addon && product(kv.addon.key) ? abs(product(kv.addon.key).url) : null,
      'Kit Variant ID': kit && kit.v ? kit.v.id : null,
      'Kit Price': kit && kit.v ? kit.v.price / 100 : (COPY[st.id + '-' + st.type] || { kit: {} }).kit[st.look].price,
      'Kit URL': kit ? abs(kit.p.url + (kit.v ? '?variant=' + kit.v.id : '')) : null,
      'Kit Image': kit && ((kit.v && kit.v.img) || kit.p.img) ? abs((kit.v && kit.v.img) || kit.p.img) : null,
      'Picked For You': picks,
      'Opted In': d.consent
    });
    /* Email 1 content: everything the Curl ID results email needs, so one Klaviyo template covers all 36 results */
    var cc = COPY[st.id + '-' + st.type];
    var FRX = d.lang === 'fr' && window.CURL_ID_EMAIL_FR, FRT = FRX ? FRX.t : {};
    var tr = function (x) { return x == null ? x : (FRT[x] || x); };
    if (cc) {
      var rt = cc.routine[st.look] || cc.routine.definition || [];
      Object.assign(evProps, {
        'Curl ID Tagline': tr(cc.tagline),
        'Curl ID Type Label': tr(cc.curlTypeLabel),
        'Curl ID Type Noun': FRX ? FRX.nouns[TYPE_NOUN[st.type]] : TYPE_NOUN[st.type],
        'Curl ID Look Label': FRX ? FRX.looks[LOOKS[st.look]] : LOOKS[st.look],
        'Curl ID Strands Label': tr(cc.strands),
        'Curl ID Porosity Label': tr(cc.porosity),
        'curl_id_explained': cc.explained.map(tr),
        'Curl ID Superpower': capFirst(tr(cc.superpower)),
        'Curl ID Challenge': capFirst(tr(cc.challenge)),
        'Curl ID Why Let Down': cc.whyLetDown ? capFirst(tr(cc.whyLetDown)) : null,
        'curl_id_symptoms': cc.symptoms.map(tr),
        'routine_steps': rt.map(function (r, i) { return { n: i + 1, verb: tr(r.verb), product: r.product ? NAMES[r.product] : '', text: tr(r.text) }; }),
        'kit_items': kv.items.map(function (i) { return { name: NAMES[i.product], line: tr(i.line) }; }),
        'Kit Name': FRX ? FRX.kitName.replace('{name}', CURL_IDS[st.id].name) : CURL_IDS[st.id].name + ' Curl ID Kit',
        'Before Image': m.before ? abs(m.before) : null,
        'After Image': (function () { var af = m[{ definition: 'afterDefinition', volume: 'afterVolume', both: 'afterBoth' }[st.look]] || m.afterDefinition; return af ? abs(af) : null; })(),
        'Kit Compare Price': kit && kit.v && kit.v.compare > kit.v.price ? kit.v.compare / 100 : null,
        'Kit Add-On Line': kv.addon ? tr(kv.addon.line) : null,
        'Kit Add-On Price': kv.addon ? kv.addon.v.price / 100 : null,
        'Quiz URL': abs(location.pathname),
        'Stylist Name': (CFG.stylist && CFG.stylist.name) || null
      });
    }
    /* Save the email content on the profile too, so the Curl ID emails can use {{ person|lookup:'...' }} (latest quiz wins) */
    ['Kit Products', 'Kit Add-On', 'Kit Add-On URL', 'Kit Price', 'Kit URL', 'Kit Image', 'Curl ID Tagline', 'Curl ID Type Label', 'Curl ID Type Noun',
     'Curl ID Strands Label', 'Curl ID Porosity Label', 'curl_id_explained', 'Curl ID Superpower', 'Curl ID Challenge', 'Curl ID Why Let Down',
     'curl_id_symptoms', 'routine_steps', 'kit_items', 'Kit Name', 'Before Image', 'After Image', 'Kit Compare Price', 'Kit Add-On Line',
     'Kit Add-On Price', 'Quiz URL', 'Stylist Name', 'Curl ID Look Label'].forEach(function (k) { if (k in evProps) props[k] = evProps[k]; });
    var profile = { email: d.email, properties: props };
    if (d.first) profile.first_name = d.first;
    var base = 'https://a.klaviyo.com/client/', qs = '?company_id=' + encodeURIComponent(K.publicKey);
    var headers = { 'Content-Type': 'application/json', revision: K.revision || '2024-10-15' };
    var jobs = [fetch(base + 'events/' + qs, { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'event', attributes: {
      properties: evProps, metric: { data: { type: 'metric', attributes: { name: K.metric || 'Curl ID Quiz Completed' } } },
      profile: { data: { type: 'profile', attributes: profile } }, unique_id: d.email + '-' + Date.now() } } }) })];
    if (d.consent && K.listId) {
      jobs.push(fetch(base + 'subscriptions/' + qs, { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Curl ID quiz', profile: { data: { type: 'profile', attributes: { email: d.email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: K.listId } } } } }) }));
    }
    return Promise.all(jobs).then(function (rs) {
      rs.forEach(function (r) { if (!r.ok) { r.text().then(function (t) { console.warn('[Curl ID] Klaviyo rejected the request (' + r.status + '):', t); }); throw new Error('Klaviyo ' + r.status); } });
      console.info('[Curl ID] Sent to Klaviyo (script version 2026-10-15c): profile + event with ' + Object.keys(evProps).length + ' fields.');
    });
  }

  /* ---------- Picked for you (PRODUCT_RULES) ---------- */
  function cadence(copy, key, fallback) {
    var t = copy && copy.addons && (copy.addons.treatments || []).filter(function (x) { return x.product === key; })[0];
    return t ? t.cadence.charAt(0).toUpperCase() + t.cadence.slice(1) : fallback;
  }
  function buildPicks(st) {
    var copy = COPY[st.id + '-' + st.type], low = CURL_IDS[st.id].por === 'low';
    var inKit = copy ? copy.kit[st.look].items.map(function (i) { return i.product; }) : [];
    var out = [], seen = {};
    function add(key, why, when) { if (seen[key] || inKit.indexOf(key) > -1 || !product(key)) return; seen[key] = 1; out.push({ key: key, why: why, when: when }); }
    var scalp = st.scalp.filter(function (v) { return v !== 'none'; }), dmg = st.history.filter(function (v) { return DAMAGE.indexOf(v) > -1; });
    var tangles = st.history.indexOf('detangling') > -1, life = st.life, protective = st.goal === 'protective' || life.indexOf('extensions') > -1;
    if (scalp.length) add('renaissance', 'You said your scalp is ' + listJoin(scalp.map(function (v) { return label('scalp', v).toLowerCase(); })) + '. Curl Renaissance clears the buildup that\'s usually behind it.', cadence(copy, 'renaissance', 'Monthly reset'));
    if (dmg.length) {
      var what = listJoin(dmg.map(function (v) { return { colour: 'colour', straightening: 'chemical straightening', heat: 'heat styling', breakage: 'breakage' }[v]; }));
      if (low) add('unconditional_love', 'You told us about ' + what + '. Unconditional Love adds deep hydration plus protein to bring back strength.', cadence(copy, 'unconditional_love', 'Every 2nd wash day, as a deep treatment'));
      else add('curl_repair', 'You told us about ' + what + '. Curl Repair is a reconstructive protein treatment that rebuilds strength.', cadence(copy, 'curl_repair', 'Every 3 to 4 weeks'));
    }
    if (protective) add('renaissance', 'Protective styles and extensions trap buildup. Curl Renaissance keeps your scalp clean during your style and on takedown day.', cadence(copy, 'renaissance', 'Monthly reset'));
    if (life.indexOf('swim') > -1) add('renaissance', 'You swim regularly. Curl Renaissance clears out chlorine and salt after your swims.', 'After swimming, before Curl Renew');
    if (life.indexOf('workout') > -1) add('renaissance', 'You work out. Curl Renaissance clears the sweat and buildup that come with it.', cadence(copy, 'renaissance', 'Monthly reset'));
    var refreshWhy = [];
    if (life.indexOf('workout') > -1) refreshWhy.push('you work out');
    if (tangles) refreshWhy.push('detangling can be tough');
    if (protective) refreshWhy.push('your hair needs hydration under your style');
    if (life.indexOf('swim') > -1) refreshWhy.push('you swim');
    var why = refreshWhy.length ? 'You told us ' + listJoin(refreshWhy) + '. Daily Curl Booster and Mistify refresh your curls and add slip.' : 'Daily Curl Booster and Mistify bring your curls back to life between wash days.';
    if (product('refresh_kit')) add('refresh_kit', why, 'Between wash days' + (life.indexOf('workout') > -1 ? ' and after workouts' : ''));
    else { add('daily_curl_booster', why, 'Between wash days'); add('mistify', 'A light mist to refresh your curls between wash days.', 'Between wash days'); }
    return out.slice(0, 4);
  }

  /* ---------- Result page ---------- */
  var RS = null;
  function renderResult(st) {
    RS = st;
    var copy = COPY[st.id + '-' + st.type];
    if (!copy) { root.innerHTML = '<p class="cid-noscript">We couldn\'t find that Curl ID. <a href="' + esc(location.pathname) + '">Retake the quiz</a></p>'; return; }
    if (st.code) { fetch((CFG.routes.root || '/').replace(/\/$/, '') + '/discount/' + encodeURIComponent(st.code)).catch(function () {}); }
    root.setAttribute('data-view', 'result');
    root.innerHTML = resultHtml(st, copy);
    var v = root.querySelector('.cid-video video'); if (v) v.load();
  }
  function productCard(key, opts) {
    opts = opts || {};
    var p = product(key), v = pickVariant(p, opts.prefer);
    var img = p && p.img;
    return '<div class="cid-pcard">' +
      '<a class="cid-pcard-img" href="' + esc(p ? p.url : '#') + '"' + (p ? '' : ' aria-disabled="true"') + '>' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="cid-pcard-body">' + (opts.top || '') + '<a class="cid-pcard-t" href="' + esc(p ? p.url : '#') + '">' + esc(opts.name || NAMES[key]) + '</a>' +
      (opts.text ? '<p>' + esc(opts.text) + '</p>' : '') + (opts.when ? '<p class="cid-when">' + esc(opts.when) + '</p>' : '') +
      '<div class="cid-pcard-buy">' + (v ? '<span class="cid-price">' + money(v.price) + '</span><button type="button" class="cid-add" data-add="' + v.id + '" aria-label="Add ' + esc(NAMES[key]) + ' to cart">Add</button>' : '<span class="cid-soldout">' + (p ? 'Sold out' : '') + '</span>') + '</div>' +
      '</div></div>';
  }
  function resultHtml(st, copy) {
    var c = CURL_IDS[st.id], look = st.look, kitData = copy.kit[look], kv = kitView(copy, st.id + '-' + st.type, look), kit = kv.kit, addon = kv.addon;
    var m = kit && kit.p.media || {}, emailed = ses('cid_emailed') === '1' || (store(STORE_KEY) || {}).emailed;
    var kitImg = kit && ((kit.v && kit.v.img) || kit.p.img);
    var kitPrice = kit && kit.v ? money(kit.v.price) : '$' + kitData.price;
    var canBuyKit = kit && kit.v && kit.v.available;
    var gift = st.code ? '<p class="cid-giftline"><strong>Your welcome gift is applied:</strong> an extra 5% off your Curl ID Kit (15% off in total), plus our 30-Day Curl Expert Guarantee. Valid for 7 days. We\'ve also sent your results and your styling guide to your inbox.</p>'
      : emailed ? '<p class="cid-giftline cid-giftline-inbox"><strong>Your extra 5% is in your inbox.</strong> Grab it before checkout: 15% off your kit in total, plus our 30-Day Curl Expert Guarantee. Valid for 7 days.</p>' : '';
    var rating = kit && kit.p.rating ? '<div class="cid-rating"><span aria-hidden="true">★</span> ' + Number(kit.p.rating).toFixed(1) + (kit.p.ratingCount ? ' from ' + kit.p.ratingCount + ' reviews' : '') + '</div>' : '';
    var toggle = '<div class="cid-toggle" role="group" aria-label="Choose your look">' + Object.keys(LOOKS).map(function (k) {
      return '<a href="' + esc(urlFor(st, k)) + '" data-look="' + k + '" aria-pressed="' + (k === look) + '">' + esc(LOOKS[k]) + '</a>';
    }).join('') + '</div>';

    /* 1. Hero + kit */
    var h = '<div class="cid-result">' +
      '<section class="cid-r-hero"><div class="cid-r-id">' +
      '<div class="cid-reveal-k">Your Curl ID is</div>' + nameHtml(c.name, 'cid-idname-xl') +
      '<div class="cid-pills">' + chipsFor(st.id, st.type) + '</div>' +
      '<p class="cid-reveal-tag">' + esc(copy.tagline) + '</p>' + toggle +
      '<p class="cid-help">Switching updates your kit, routine, photos and video below.</p></div>' +
      '<div class="cid-kit"><div class="cid-kit-k">Made for your Curl ID</div>' + rating +
      (kitImg ? '<img class="cid-kit-img" src="' + esc(kitImg) + '" alt="' + esc(c.name) + ' Curl ID Kit, ' + esc(LOOKS[look]) + '">' : '') +
      '<h2 class="cid-kit-t">' + esc(c.name) + ' Curl ID Kit</h2>' +
      '<p class="cid-kit-sub">Type ' + st.type + ' · ' + esc(LOOKS[look]) + ' · made for ' + esc(copy.strands) + ' strands and ' + esc(copy.porosity) + ' porosity</p>' +
      '<div class="cid-kit-inc">' + (kit && kit.fallback ? 'Your Definition kit' : 'What\'s included') + '</div><ul class="cid-kit-list">' + kv.items.map(function (i) {
        return '<li><strong>' + esc(NAMES[i.product]) + '</strong> ' + esc(i.line) + '</li>';
      }).join('') + '</ul>' +
      '<div class="cid-kit-price">' + (kit && kit.v && kit.v.compare > kit.v.price ? '<s class="cid-was">' + money(kit.v.compare) + '</s> ' : '') + kitPrice +
      (kit && kit.v && kit.v.compare > kit.v.price ? ' <span class="cid-save">You save ' + money(kit.v.compare - kit.v.price) + '</span>' : '') + '</div>' +
      (addon ? '<div class="cid-addon"><div class="cid-box2-k">Add for Volume + Definition</div><p><strong>' + esc(NAMES[addon.key]) + '</strong> ' + esc(addon.line) + ' <span class="cid-price">' + money(addon.v.price) + '</span></p>' +
        (kv.dropsML ? '<p class="cid-help">For your Volume &amp; Definition look, skip Moisture Lock so your curls stay light. Save it for days you want more definition.</p>' : '') + '</div>' : '') +
      (st.code ? '' : gift) +
      (canBuyKit && addon && addon.v.available ? '<button type="button" class="cid-btn cid-btn-block" data-addkit="' + kit.v.id + ',' + addon.v.id + '">Add my kit + ' + esc(NAMES[addon.key]) + ', ' + money(kit.v.price + addon.v.price) + '</button>' +
          '<button type="button" class="cid-link" data-addkit="' + kit.v.id + '">Just the Definition kit, ' + money(kit.v.price) + '</button>'
        : canBuyKit ? '<button type="button" class="cid-btn cid-btn-block" data-addkit="' + kit.v.id + '">Add my kit to cart</button>'
        : '<a class="cid-btn cid-btn-block" href="#cid-build">Shop my routine</a>') + (st.code ? gift : '') +
      '<a class="cid-link" href="#cid-build">Prefer to build your own?</a></div></section>';

    /* 2. What your hair is craving */
    h += '<section class="cid-r-sec cid-crave"><h2 class="cid-h2"><span class="cid-h2-a">What your hair</span> <span class="cid-script">is craving</span></h2>' +
      copy.explained.map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('') +
      '<div class="cid-two"><div class="cid-box2"><div class="cid-box2-k">Your superpower</div><p>' + esc(capFirst(copy.superpower)) + '</p></div>' +
      '<div class="cid-box2"><div class="cid-box2-k">Your challenge</div><p>' + esc(capFirst(copy.challenge)) + '</p></div></div>' +
      (copy.whyLetDown ? '<p><strong>Why so many products let you down:</strong> ' + esc(capFirst(copy.whyLetDown)) + '</p>' : '') +
      '<div class="cid-sound"><div class="cid-box2-k">Does this sound like your hair?</div><ul>' + copy.symptoms.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul>' +
      '<p class="cid-help">Something doesn\'t sound like you? <a href="' + esc(location.pathname) + '" data-retake>Retake the quiz</a>. Take your time on the porosity question: it\'s the one that changes your routine the most.</p></div></section>';

    /* 3. Picked for you */
    var picks = buildPicks(st);
    if (picks.length) h += '<section class="cid-r-sec"><h2 class="cid-h2"><span class="cid-h2-a">Picked</span> <span class="cid-script">for you</span></h2>' +
      '<p class="cid-lede">Based on what you told us about your scalp, your hair story and your week.</p><div class="cid-pgrid">' +
      picks.map(function (p) { return productCard(p.key, { text: p.why, when: p.when, prefer: p.key === 'renaissance' ? /2\s?oz|60\s?ml/i : null }); }).join('') + '</div></section>';

    /* 4. Build your own */
    var steps = copy.routine[look], buyable = [];
    h += '<section class="cid-r-sec" id="cid-build"><h2 class="cid-h2"><span class="cid-h2-a">Build</span> <span class="cid-script">your own</span></h2>' +
      '<p class="cid-lede">Your ' + esc(LOOKS[look]) + ' routine, step by step. Buy it all or just what you need.</p><ol class="cid-steps">' +
      steps.map(function (s, i) {
        var top = '<div class="cid-step-n"><span>' + (i + 1) + '</span>' + esc(s.verb) + '</div>';
        if (!s.product) return '<li class="cid-step cid-step-plain">' + top + '<p>' + esc(capFirst(s.text)) + '</p></li>';
        var v = pickVariant(product(s.product)); if (v) buyable.push(v);
        return '<li class="cid-step">' + productCard(s.product, { top: top, text: capFirst(s.text) }) + '</li>';
      }).join('') + '</ol>';
    if (buyable.length) {
      var total = buyable.reduce(function (a, v) { return a + v.price; }, 0);
      h += '<button type="button" class="cid-btn cid-btn-ghost" data-addall="' + buyable.map(function (v) { return v.id; }).join(',') + '">Add all ' + buyable.length + ' to cart, ' + money(total) + '</button>';
    }
    if (copy.extraStylers && copy.extraStylers.length) h += '<div class="cid-extra"><div class="cid-box2-k">Play with your look</div><p>Want to switch things up? Your Curl ID also loves ' +
      listJoin(copy.extraStylers.map(function (k) { return NAMES[k]; })) + '.</p><div class="cid-pgrid">' +
      copy.extraStylers.map(function (k) { return productCard(k); }).join('') + '</div></div>';
    var wc = CURL_IDS[st.id].por === 'low' ? 'wc_low' : 'wc_medhigh';
    if (product(wc)) h += '<div class="cid-start"><div class="cid-box2-k">Just starting out?</div>' +
      productCard(wc, { text: 'Curl Renew and your conditioner. Add a styler later.' }) + '</div>';
    h += '</section>';

    /* 5. Applying your products the right way */
    var ap = copy.applying;
    if (ap) {
      var hasML = kitData.items.some(function (i) { return i.product === 'moisture_lock'; });
      var res = ap.residue.steps.filter(function (s) { return hasML || !/Moisture Lock/.test(s); });
      h += '<section class="cid-r-sec"><details class="cid-apply"' + (hasML ? ' open' : '') + '><summary><h2 class="cid-h2"><span class="cid-h2-a">Applying your products</span> <span class="cid-script">the right way</span></h2></summary>' +
        '<p>' + esc(ap.intro) + '</p>' + ap.steps.map(function (s) { return '<p>' + boldLead(s) + '</p>'; }).join('') +
        (hasML ? '<div class="cid-ml"><p>' + boldLead(ap.moistureLock) + '</p><ol>' + ap.mlSteps.map(function (s) { return '<li>' + boldLead(s) + '</li>'; }).join('') + '</ol></div>' : '') +
        ap.after.map(function (s) { return '<p>' + esc(s) + '</p>'; }).join('') +
        '<div class="cid-residue"><p>' + boldLead(ap.residue.intro) + '</p><ol>' + res.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ol>' +
        (hasML ? ap.residue.outro.map(function (s) { return '<p>' + esc(s) + '</p>'; }).join('') : '') +
        (look === 'both' && ap.residue.volumeDefinitionOnly ? '<p>' + esc(ap.residue.volumeDefinitionOnly) + '</p>' : '') + '</div></details></section>';
    }

    /* 6. Results + video */
    var after = m[{ definition: 'afterDefinition', volume: 'afterVolume', both: 'afterBoth' }[look]] || m.afterDefinition;
    var video = m[{ definition: 'videoDefinition', volume: 'videoVolume', both: 'videoBoth' }[look]] || m.videoDefinition;
    if ((m.before && after) || video) {
      h += '<section class="cid-r-sec"><h2 class="cid-h2"><span class="cid-h2-a">See the</span> <span class="cid-script">results</span></h2>';
      if (m.before && after) h += '<div class="cid-ba"><figure><img src="' + esc(m.before) + '" alt="Before" loading="lazy"><figcaption>Before</figcaption></figure>' +
        '<figure><img src="' + esc(after) + '" alt="After, ' + esc(LOOKS[look]) + '" loading="lazy"><figcaption>After</figcaption></figure></div>';
      if (video) h += '<div class="cid-video"><div class="cid-box2-k">Your routine for ' + esc(LOOKS[look]) + '</div>' + videoEmbed(video) +
        '<p class="cid-help">Watch the full wash day from start to finish.</p></div>';
      h += '</section>';
    }

    /* 7. Styling guide */
    if (m.guideEn || m.guideFr) {
      var fr = lang() === 'fr';
      var main = fr && m.guideFr ? m.guideFr : (m.guideEn || m.guideFr), alt = fr ? m.guideEn : m.guideFr;
      h += '<section class="cid-r-sec cid-guide"><div class="cid-box2-k">Keep it handy</div><h2 class="cid-h2"><span class="cid-h2-a">Your styling</span> <span class="cid-script">guide</span></h2>' +
        '<p>Every product and technique for your hair type.' + (m.guideNote ? ' ' + esc(m.guideNote) : '') + '</p>' +
        '<a class="cid-btn" href="' + esc(main) + '" target="_blank" rel="noopener">Download the guide</a>' +
        (alt && alt !== main ? '<a class="cid-link" href="' + esc(alt) + '" target="_blank" rel="noopener">' + (fr ? 'Download in English' : 'Télécharger en français') + '</a>' : '') + '</section>';
    }

    /* 8. Save your plan (only for people who skipped email) */
    if (!emailed && !CFG.isB2B) h += '<section class="cid-r-sec cid-save"><h2 class="cid-h2"><span class="cid-h2-a">Save your</span> <span class="cid-script">curl care plan</span></h2>' +
      '<p>Get your Curl ID, kit, routine and styling guide in your inbox, plus your welcome gift: an extra 5% off your Curl ID Kit (15% off in total) and our 30-Day Curl Expert Guarantee.</p>' + emailForm('result') + '</section>';

    /* 9. Note from the stylist */
    var stl = CFG.stylist || {};
    h += '<section class="cid-r-sec cid-note-card">' + stylist().replace('cid-stylist', 'cid-stylist cid-stylist-lg') +
      '<div class="cid-box2-k">A note from ' + esc(firstWord(stl.name)) + '</div>' +
      '<p>Your hair isn\'t difficult. It just hasn\'t been understood yet. This is the first step, and I\'m so glad you took it.</p>' +
      '<p>You\'ll feel the difference from your very first wash day: softer, more hydrated curls. Most of our clients see results in 1-3 washes, and your curls keep getting healthier the longer you stay with your routine.</p>' +
      '<p class="cid-signoff">Claim your power. Celebrate your Inhairitance.</p></section>';

    h += '<footer class="cid-r-foot">' + (CFG.isB2B ? '' : '<p class="cid-help">Your curl care plan is saved on this device for 90 days.</p>') +
      '<a class="cid-link" href="' + esc(location.pathname) + '" data-retake>Retake the quiz</a></footer>';
    h += '<div class="cid-toast" role="status" hidden></div></div>';
    return h;
  }
  function capFirst(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function boldLead(s) { var i = s.indexOf('. '); return i > 0 && i < 60 ? '<strong>' + esc(s.slice(0, i + 1)) + '</strong> ' + esc(s.slice(i + 2)) : esc(s); }
  function videoEmbed(url) {
    var yt = /(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/.exec(url), vm = /vimeo\.com\/(\d+)/.exec(url);
    if (yt) return '<div class="cid-embed"><iframe src="https://www.youtube-nocookie.com/embed/' + yt[1] + '?rel=0&cc_load_policy=1" title="Routine video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe></div>';
    if (vm) return '<div class="cid-embed"><iframe src="https://player.vimeo.com/video/' + vm[1] + '" title="Routine video" allow="autoplay; picture-in-picture" allowfullscreen loading="lazy"></iframe></div>';
    return '<video src="' + esc(url) + '" controls playsinline preload="metadata"></video>';
  }

  /* ---------- Result events ---------- */
  function toast(msg) {
    var t = root.querySelector('.cid-toast'); if (!t) return;
    t.innerHTML = msg; t.hidden = false; clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 4000);
  }
  function addToCart(ids, kitLabel) {
    var items = ids.map(function (id) { var it = { id: Number(id), quantity: 1 }; if (kitLabel) it.properties = { _curl_id: kitLabel }; return it; });
    return fetch((CFG.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); }); return r.json(); })
      .then(function (j) { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); return j; });
  }
  root.addEventListener('click', function (e) {
    if (root.getAttribute('data-view') !== 'result') return;
    var b = e.target.closest('[data-addkit],[data-add],[data-addall],[data-look],[data-retake]'); if (!b) return;
    if (b.dataset.look) {
      e.preventDefault(); RS.look = b.dataset.look;
      try { history.replaceState({}, '', urlFor(RS)); } catch (x) {}
      saveLocal(RS); renderResult(RS);
      var k = root.querySelector('.cid-kit'); if (k && window.innerWidth < 900) k.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
      return;
    }
    if (b.hasAttribute('data-retake')) {
      e.preventDefault(); A = { goal: null, type: null, strands: null, porosity: null, scalp: [], history: [], life: [], lang: null };
      try { history.pushState({ cidStep: 0 }, '', location.pathname); } catch (x) {}
      stepIdx = 0; render(); root.scrollIntoView({ block: 'start' }); return;
    }
    var ids = b.dataset.addkit ? b.dataset.addkit.split(',') : b.dataset.add ? [b.dataset.add] : b.dataset.addall.split(',');
    var old = b.textContent; b.disabled = true; b.textContent = 'Adding...';
    var label = b.dataset.addkit ? CURL_IDS[RS.id].name + ' ' + RS.type + ' · ' + LOOKS[RS.look] : null;
    addToCart(ids, label).then(function () {
      if (b.dataset.addkit) {
        var cart = CFG.routes.cart || '/cart';
        location.href = RS.code ? (CFG.routes.root || '/').replace(/\/$/, '') + '/discount/' + encodeURIComponent(RS.code) + '?redirect=' + encodeURIComponent(cart) : cart;
        return;
      }
      b.textContent = 'Added'; toast('Added to your cart. <a href="' + esc(CFG.routes.cart || '/cart') + '">View cart</a>');
      setTimeout(function () { b.disabled = false; b.textContent = old; }, 2500);
    }, function (err) { b.disabled = false; b.textContent = old; toast(esc(err.message)); });
  });

  /* ---------- Boot ---------- */
  var p = params(), st0 = stateFromParams(p);
  if (st0) { if (st0.code) ses('cid_code', st0.code); else if (ses('cid_code')) st0.code = ses('cid_code'); saveLocal(st0); renderResult(st0); }
  else {
    if (p.goal && OPTS.goal.some(function (o) { return o.v === p.goal; })) { A.goal = p.goal; stepIdx = 1; }
    try { history.replaceState({ cidStep: stepIdx }, '', location.pathname + location.search); } catch (e) {}
    render();
  }
  /* Debug helper for setup: open the console and run CurlIDCheck() */
  window.CurlIDCheck = function () {
    var miss = Object.keys(NAMES).filter(function (k) { return !product(k); });
    var kits = Object.keys(KIT_VARIANTS).map(function (k) { return [k, ['definition', 'volume', 'both'].map(function (l) { var x = kitFor(k, l); return l + ':' + (x && x.v ? (x.fallback ? 'definition kit + add-on' : 'ok') : 'MISSING'); }).join(' ')]; });
    console.table(kits); console.log('Missing products:', miss.length ? miss : 'none'); return { missing: miss, kits: kits };
  };
})();